import { CopyIcon, MapPinIcon } from "@phosphor-icons/react";
import { useIntl } from "react-intl";

import { IconButton } from "@/components/IconButton/IconButton";
import { HotelMap } from "@/features/hotels/components/hotel/HotelMapLazy";
import type { HotelData } from "@/features/hotels/types/types";
import { copyToClipboardWithFeedback } from "@/utils/copyToClipboard";

type Props = {
  hotel: HotelData;
};

export const HotelMapDirections = ({ hotel }: Props) => {
  const intl = useIntl();

  return (
    <div className="section-card flex flex-col gap-4">
      <div className="text-lg font-medium text-text-primary">
        {intl.formatMessage({
          defaultMessage: "How to get to your hotel",
          description:
            "Hotel directions card title on hotel booking success page",
        })}
      </div>

      <HotelMap hotel={hotel} />

      {hotel.address && (
        <div className="flex w-full items-center gap-2">
          <MapPinIcon size={20} className="shrink-0 text-text-primary" />
          <p className="me-auto text-sm text-text-primary">{hotel.address}</p>
          <IconButton
            size="small"
            disablePadding
            onClick={() =>
              copyToClipboardWithFeedback(
                hotel.address,
                intl.formatMessage({
                  defaultMessage: "Hotel address copied",
                  description: "Snackbar shown after copying the hotel address",
                }),
              )
            }
            aria-label={intl.formatMessage({
              defaultMessage: "Copy address",
              description: "Button to copy the hotel address to clipboard",
            })}
          >
            <CopyIcon color="var(--color-text-tertiary)" size={20} />
          </IconButton>
        </div>
      )}
    </div>
  );
};
